export const DICE_PICK_GROUPS = [
  {
    id: "exact",
    label: "Face",
    picks: ["1", "2", "3", "4", "5", "6"],
    columns: 3,
  },
  {
    id: "parity",
    label: "Even / Odd",
    picks: ["even", "odd"],
    columns: 2,
  },
  {
    id: "range",
    label: "Interval",
    picks: ["1-3", "4-6"],
    columns: 2,
  },
];

export function formatBondDiceCoin(value) {
  const n = Math.floor(Number(value) || 0);
  return n.toLocaleString("en-US");
}

export function faceLabel(face) {
  const n = Math.floor(Number(face));
  if (!Number.isFinite(n)) return "—";
  return String(n);
}

export function resolveBondDiceSettledRound({
  revealedRound = null,
  lastSettled = null,
  ticketRound = null,
} = {}) {
  const ticketId = String(ticketRound?._id || ticketRound?.id || "");
  for (const candidate of [revealedRound, lastSettled]) {
    if (candidate?.outcome == null) continue;
    const candidateId = String(candidate._id || candidate?.id || "");
    if (!ticketId || !candidateId || candidateId === ticketId) return candidate;
  }
  return null;
}

export function resolvePlayerPick(source) {
  if (source == null) return null;
  if (typeof source === "object") {
    if (source.playerPick) return String(source.playerPick).toLowerCase();
    if (source.playerFace != null) return String(source.playerFace);
    return null;
  }
  return String(source).toLowerCase();
}

export function pickLabel(pick) {
  const p = resolvePlayerPick(pick);
  if (!p) return "—";
  if (p === "even") return "Even";
  if (p === "odd") return "Odd";
  if (p === "1-3") return "1–3";
  if (p === "4-6") return "4–6";
  return faceLabel(p);
}

export function oddsForPick(pick, constants) {
  const p = resolvePlayerPick(pick);
  if (!p) return constants?.groupOdds || constants?.odds || 2;
  const faceOdds = constants?.faceOdds || 6;
  const groupOdds = constants?.groupOdds || constants?.odds || 2;
  return /^[1-6]$/.test(p) ? faceOdds : groupOdds;
}

export function formatOddsMultiplier(odds) {
  const n = Number(odds);
  if (!Number.isFinite(n)) return "—";
  return Number.isInteger(n) ? `${n}×` : `${n.toFixed(2)}×`;
}

/** Instant gross payout quote — mirrors backend buildDiceQuote. */
export function computeBondDiceQuote(stake, pick, constants) {
  const resolvedStake = Math.floor(Number(stake) || 0);
  if (resolvedStake <= 0) return null;

  const odds = oddsForPick(pick, constants);
  if (!Number.isFinite(odds) || odds <= 1) return null;

  const grossPayout = Math.floor(resolvedStake * odds);
  const reserve = Math.max(0, grossPayout - resolvedStake);

  return {
    stake: resolvedStake,
    odds,
    grossPayout,
    reserve,
    maxWin: grossPayout,
  };
}
